export default {
  outline: "0 0 0 3px #595B5F",
};
